module.exports = __webpack_public_path__ + "static/media/IMG_0327.d56f7939.JPG";